import { render } from "./alert.vue?vue&type=template&id=3c277f9e"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"
script.render = render

export default script